import { render, staticRenderFns } from "./AssemblyView.vue?vue&type=template&id=ee627890"
import script from "./AssemblyView.vue?vue&type=script&lang=js"
export * from "./AssemblyView.vue?vue&type=script&lang=js"
import style0 from "./AssemblyView.vue?vue&type=style&index=0&id=ee627890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports